// projectReducer.js

import {  GET_EACH_WEEKLY_TS_FAILURE, GET_EACH_WEEKLY_TS_REQUEST, GET_EACH_WEEKLY_TS_SUCCESS,  } from "../Actions/Actions";




const initialState = {
  isLoading: false,
  timesheets: [],
  error: null,
};

const getEachWeekTimesheetReducer = (state = initialState,{type,payload}) => {
  switch (type) {
    case GET_EACH_WEEKLY_TS_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case GET_EACH_WEEKLY_TS_SUCCESS:
      return { ...state, isLoading: false, timesheets: payload};
    case GET_EACH_WEEKLY_TS_FAILURE:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default getEachWeekTimesheetReducer;
